import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { gql } from "@apollo/client";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  type Attributes {\n    name: String\n    id: Int\n  }\n  type GenreAttributesResult {\n    attributes: [Attributes]\n  }\n  type Query {\n    genreAttributes(ids: [Int]): GenreAttributesResult\n  }\n"])));
export var resolvers = {
  Query: {
    genreAttributes: function () {
      var _genreAttributes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, args, _ref) {
        var dataSources, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dataSources = _ref.dataSources;
                _context.next = 3;
                return dataSources.attributes.genreAttributes(args);

              case 3:
                res = _context.sent;
                return _context.abrupt("return", res);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function genreAttributes(_x, _x2, _x3) {
        return _genreAttributes.apply(this, arguments);
      }

      return genreAttributes;
    }()
  }
};